import { Range } from 'nomst/Stores/Decision/range';

export interface Bar {
    min: number;
    max: number;
    minText: string;
    maxText: string;
}

export class RangeChartHelper {
    public static getMin(bar1: Nullable<Bar>, bar2: Nullable<Bar>): number {
        if (!bar1) {
            return bar2 ? bar2.min : 0;
        }

        if (!bar2) {
            return bar1.min;
        }

        return Math.min(bar1.min, bar2.min);
    }

    public static getMax(bar1: Nullable<Bar>, bar2: Nullable<Bar>): Nullable<number> {
        if (!bar1) {
            // if there's no bar1 or bar2, return null to indicate invalid params
            return bar2 ? bar2.max : null;
        }

        if (!bar2) {
            return bar1.max;
        }

        return Math.max(bar1.max, bar2.max);
    }

    public static getJobRangeBar(range: Range): Nullable<Bar> {
        if (!range) {
            return null;
        }
        return {
            min: range.convertedMinRange,
            max: range.convertedMaxRange,
            minText: range.minRange?.toString(),
            maxText: range.maxRange?.toString()
        } as Bar;
    }
}